const RES_STORAGE_KEY = 'res';
const DEFAULT_RES = 'high';

export const getStoredRes = (): string => {
  return window.localStorage.getItem(RES_STORAGE_KEY) || DEFAULT_RES;
};

export const setStoredRes = (res: string): void => {
  if (typeof window === 'undefined') {
    return;
  }

  window.localStorage.setItem(RES_STORAGE_KEY, res );
};

export const getInitialRes = (search: string): string => {
  const queryRes = new URLSearchParams(search).get('res');

  if (queryRes) {
    setStoredRes(queryRes);
    return queryRes;
  }

  return getStoredRes();
};